import React from 'react'

// Placeholder cards shown while a feed is loading
const FeedSkeleton = ({ count = 3, label = 'Loading' }) => {
  return (
    <div role="status" aria-busy="true" aria-live="polite">
      <span className="visually-hidden">{label}…</span>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card bl-feed-card mb-3" aria-hidden="true">
          <div className="bl-skeleton mb-3" style={{ width: 88, height: 22 }}></div>
          <div className="bl-skeleton mb-2" style={{ height: 14, width: '80%' }}></div>
          <div className="bl-skeleton" style={{ height: 14, width: '55%' }}></div>
        </div>
      ))}
    </div>
  )
}

export default FeedSkeleton
